import { createContext } from 'react';

const alertasDispositivoContext = createContext();

export default alertasDispositivoContext;